module.exports = {
    "small": 660,
    "medium": 768,
    "large": 1200,
    "menularge": 1400,
    "offersMedium": 1360,
    "offersLarge": 1420,
    "servicesLarge": 1480,
    "xLarge": 1538,
    "xxLarge": 1600,
    "xxxLarge": 1700,
}

